import type { ThemeOptions } from "@mui/material/styles";

const PLAYER_FONT_STACK = [
  "Inter",
  "ui-sans-serif",
  "system-ui",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "sans-serif",
].join(", ");

export const PLAYER_TYPOGRAPHY = {
  fontFamily: PLAYER_FONT_STACK,
  h1: {
    fontSize: "clamp(1.65rem, 3vw, 2.15rem)",
    lineHeight: 1.12,
    fontWeight: 700,
    letterSpacing: "-0.035em",
  },
  h2: {
    fontSize: "clamp(1.3rem, 2vw, 1.55rem)",
    lineHeight: 1.2,
    fontWeight: 700,
    letterSpacing: "-0.025em",
  },
  h3: {
    fontSize: "1.125rem",
    lineHeight: 1.28,
    fontWeight: 650,
  },
  h6: {
    fontSize: "1.125rem",
    lineHeight: 1.35,
    fontWeight: 650,
    letterSpacing: "-0.02em",
  },
  subtitle1: {
    fontSize: "0.975rem",
    lineHeight: 1.4,
    fontWeight: 600,
  },
  body1: {
    fontSize: "0.95rem",
    lineHeight: 1.55,
  },
  body2: {
    fontSize: "0.84rem",
    lineHeight: 1.5,
  },
  button: {
    fontSize: "0.875rem",
    fontWeight: 650,
    letterSpacing: "0",
    textTransform: "none",
  },
  caption: {
    fontSize: "0.75rem",
    lineHeight: 1.45,
  },
} satisfies ThemeOptions["typography"];
